import { Address, hexToBigInt } from 'viem';

import toast from '#/components/common/toast';

import SHIZOKEY_ABI from '#/features/nft/abi';
import EthereumWallet, {
  EthereumAddress,
} from '#/features/wallets/ethereum/wallet';

import type { Config as WagmiConfig } from 'wagmi';

const CONTRACT_ADDRESS = "0x0742399E64739d500D707343b57DdF893e3caAe7" as Address;
const TRANSFER_EVENT =
  '0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef';

export async function getCurrentTokenId(
  wagmiConfig: WagmiConfig,
): Promise<bigint> {
  return (await EthereumWallet.readContract(wagmiConfig, {
    address: CONTRACT_ADDRESS,
    abi: SHIZOKEY_ABI,
    functionName: 'currentTokenId',
  })) as bigint;
}

export async function getHasMinted(
  wagmiConfig: WagmiConfig,
  address: EthereumAddress,
): Promise<boolean> {
  const result = (await EthereumWallet.readContract(wagmiConfig, {
    address: CONTRACT_ADDRESS,
    abi: SHIZOKEY_ABI,
    functionName: 'hasMinted',
    args: [address],
    account: address,
  })) as boolean;
  return result;
}

export async function mintTo(
  wagmiConfig: WagmiConfig,
  address: EthereumAddress,
): Promise<number | null> {
  try {
    const { request } = await EthereumWallet.simulateContract(wagmiConfig, {
      address: CONTRACT_ADDRESS,
      abi: SHIZOKEY_ABI,
      functionName: 'mintTo',
      args: [address],
      account: address,
    });

    toast.info('Approve transaction in your wallet...');
    const hash = await EthereumWallet.writeContract(wagmiConfig, request);
    toast.info('Transaction sent, waiting for confirmation...');
    const receipt = await EthereumWallet.waitForTransaction(wagmiConfig, {
      hash,
    });
    const mintEvent = receipt.logs.find(
      (log) => log.topics[0] === TRANSFER_EVENT,
    );

    if (mintEvent != null && mintEvent.topics[3] != null) {
      const tokenId = Number(hexToBigInt(mintEvent.topics[3]));
      toast.success('Minted your Shizo Key!');
      return tokenId;
    }
  } catch (error) {
    toast.error('Something went wrong during minting.');
  }
  return null;
}
